module.exports = __webpack_public_path__ + "img/frame (83).b871722c.jpg";